import { createSelector } from 'reselect';

const selectDomain = (state) => state.rules;

export const selectRuleSections = createSelector(
  [selectDomain], (state) => state.get('sections'),
);

export const selectRulePages = createSelector(
  [selectDomain], (state) => state.get('pages'),
);

export const selectRulesLoaded = createSelector(
  [selectDomain], (state) => state.get('loaded'),
);
